
export default [
    {
        path: '/manage/cancellation',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '作废审核',
            keepAlive: false
        }
    },
];
  